import React, { useEffect, useState } from "react";

import WorkspaceStat from "components/WorkspaceStat";
import UsageStat from "components/UsageStat";
import UploadVolumeChart from "components/UploadVolumeChart";
import RecentActivity from "components/RecentActivity";
import Task, { taskTypes } from "components/Task";
import variables from "scss/global/_variables.scss";

const HomeSummaryContent = () => {
  const [hideDivider, setHideDivider] = useState(false);

  useEffect(() => {
    if (window.Application !== undefined) {
      window.Application.Dropzone.setupDropzone();
    }
    const mediaWatcher = window.matchMedia(
      `(min-width: ${variables.widthColumn1Trigger})`
    );
    setHideDivider(mediaWatcher.matches);
    const handleResize = (e) => setHideDivider(e.matches);
    mediaWatcher.addEventListener("change", handleResize);
    return () => {
      mediaWatcher.removeEventListener("change", handleResize);
    };
  }, []);

  return (
    <div className="home_summary" data-testid="home-summary">
      <div className="home_summary__column1">
        <span className="home_summary__column1__title">Get Started</span>
        <span className="home_summary__column1__description">
          Start by uploading your PDF, Word or Excel files for analysis
        </span>
        <div className="home_summary__column1__task_list">
          <Task type={taskTypes.createFolder} />
          <Task
            type={taskTypes.uploadDocuments}
            args={{ chooseFolder: true }}
          />
        </div>
        <div className="home_summary__workspace_stats">
          <span className="home_summary__column1__title">Workspace Stats</span>
          <span className="home_summary__column1__description">
            Data in your workspace
          </span>
          <div className="home_summary__column1__workspace_stats__container">
            <WorkspaceStat
              type="folders"
              values={[window.HomeSummaryPageObject.numberFolders]}
            />
            <WorkspaceStat
              type="documents"
              values={[window.HomeSummaryPageObject.numberDocuments]}
            />
            <WorkspaceStat
              type="dictionaries"
              values={[window.HomeSummaryPageObject.numberDictionaries]}
              hideDivider={hideDivider}
            />
            <WorkspaceStat
              type="users"
              values={[window.HomeSummaryPageObject.numberActiveUsers]}
              hideDivider
            />
          </div>
        </div>
        <div className="home_summary__column1__usage_stats">
          <span className="home_summary__column1__title">Usage Stats</span>
          <span className="home_summary__column1__description">
            Workspace activity totals
          </span>
          <div className="home_summary__column1__usage_stats__container">
            <UsageStat
              type="sign-ins"
              values={[window.HomeSummaryPageObject.usageStats[1][1]]}
            />
            <UsageStat
              type="simple-shreds"
              values={[window.HomeSummaryPageObject.usageStats[0][1]]}
            />
            <UsageStat
              type="pdf-reports"
              values={[window.HomeSummaryPageObject.usageStats[2][1]]}
            />
            <UsageStat
              type="exports"
              values={[window.HomeSummaryPageObject.usageStats[3][1]]}
            />
          </div>
        </div>
      </div>
      <div className="home_summary__column2">
        <div className="home_summary__recent_activity">
          <RecentActivity
            activity={window.HomeSummaryPageObject.recentActivity}
          />
        </div>
        <div className="home_summary__recent_uploads">
          <UploadVolumeChart
            chartData={window.HomeSummaryPageObject.recentMonthlyUploadVolume}
          />
        </div>
      </div>
    </div>
  );
};

export default HomeSummaryContent;
